import Amplify from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'

/* eslint-disable class-methods-use-this */
export default class DriverCognito {
  constructor() {
    Amplify.configure({
      Auth: {
        region: process.env.VUE_APP_AWS_REGION,

        userPoolId: process.env.VUE_APP_COGNITO_DRIVER_POOL_ID,

        userPoolWebClientId: process.env.VUE_APP_COGNITO_DRIVER_CLIENT_ID,
      },
    })
  }

  async register(phoneNumber, passcode) {
    try {
      const driver = await Auth.signUp(
        phoneNumber,
        `00${passcode}`,
      )
      return { created: true, driver }
    } catch (error) {
      return { created: false, error }
    }
  }

  async verifyPhoneNumber(username, code) {
    try {
      await Auth.confirmSignUp(username, code)
      return { verified: true }
    } catch (error) {
      return { verified: false, error }
    }
  }

  async resendConfirmationCode(username) {
    return Auth.resendSignUp(username)
  }
}
